<template>
  <div class="etr">
    <b-card class="mt-3">
      <b-card-header>
        <b-row align-v="top" no-gutters>
          <b-col cols="auto">
            <b-button v-print="'#eticket'" squared size="sm" class="mr-1" title="Print" :disabled="busy">
              <i class="fa fa-print pr-3"></i>Print
            </b-button>
          </b-col>
          <b-col v-if="selection.length > 1">
            <b-form-radio-group v-model="isgroupetr" :options="[
              { text: 'Individual', value: false },
              { text: 'Group', value: true },
            ]" buttons button-variant="outline-success" size="sm" name="radio-btn-outline"
              class="mr-1"></b-form-radio-group>
            : {{ items.length }}
          </b-col>
          <b-col class="text-right">
            <b-button-group>
              <b-form-radio-group v-model="documentformat" :options="[
                { text: 'v1', value: 'ETR_1' },
                { text: 'v2 (Latest)', value: 'ETR_2' }
              ]" buttons button-variant="outline-success" size="sm" name="radio-btn-outline"></b-form-radio-group>

              <b-button class="mr-1" squared size="sm" variant="primary" @click="download()">
                <i :class="busy
                  ? 'fa fa-spinner fa-spin pr-3'
                  : 'fa fa-file-pdf-o pr-3'
                  "></i>Download
              </b-button>
              <b-button squared size="sm" variant="secondary" @click="discard">
                <i class="fa fa-chevron-left pr-1"></i>Back
              </b-button></b-button-group>
          </b-col>
        </b-row>
      </b-card-header>

      <div class="h1 text-center text-primary">
        <b-spinner v-if="busy" type="grow" label="Loading ETR"></b-spinner>
      </div>

      <b-card-body v-if="items.length > 0 && documentformat == 'ETR_1'">
        <div id="eticket" class="mb-3 p-5 background-white text-secondary eticket">
          <div>
            <b-row class="text-muted header">
              <b-col>ETR Electronic Ticket Receipt</b-col>
              <b-col class="text-center"><img class="logo" src="/img/brand/RGB Travel Places Primary Logo.bmp"
                  alt="Travel Places" height="70" width="190" /></b-col>
              <b-col class="text-right">
                Podium House <br />
                61 Chapel Road, Worthing<br />
                West Sussex<br />
                BN11 1HR<br />
                Tel: 01903 832888 Fax: 01903 231179
              </b-col>
            </b-row>
            <b-row class="mt-5">
              <b-col>
                <span v-if="isgroupetr == false" class="strong">{{
                  items[0].passenger
                }}</span>
                <br />
                Consultant: <span class="strong">{{ items[0].agent }}</span>
              </b-col>
              <b-col cols="6">
                <h4>
                  {{ items[0].eventname }} <br />
                  Itinerary
                </h4>
              </b-col>
              <b-col cols="" class="text-right">Issued:
                <span class="strong">{{ items[0].dateissued }}</span>
                <br />
                <span class="text-muted">Locator:
                  <span class="strong">{{ items[0].locator }}</span></span></b-col>
            </b-row>
            <b-row v-for="(item, index) in items[0].items" :key="index" class="border-secondary mb-2">
              <b-col>
                Date:&nbsp;
                <span class="strong">{{ $moment.unix(item.startdate * 0.001).utc(false).format('dddd, DD MMM
                  YYYY')}}</span>
                <!-- (item.startdate * 0.001) | moment("dddd, DD MMM YYYY") -->
                <br />
                Depart: &nbsp;<span class="strong">{{ item.startcityname }} </span><br />
                Arrive: &nbsp;<span class="strong">{{ item.endcityname }}
                </span></b-col>

              <b-col cols="5">
                Flight:&nbsp;<span class="strong">{{ item.flightno }} {{ item.operatingcarriername }} </span><br />
                &nbsp;<span class="strong">{{ item.starttime }} hrs, </span>Terminal: <span class="strong">{{
                  item.startterminal }}</span><br />
                <span class="strong">{{ item.endtime }} hrs, </span>Terminal:
                <span class="strong">{{ item.endterminal }}</span>
                <br />
                <span v-if="item.baggage">Baggage: &nbsp;<span class="strong">{{ item.baggage }}</span>
                </span>
                &nbsp;&nbsp;
                <span v-if="item.vendorlocator && items[0].farecalculation != 'CHARTER'"
                  class="text-danger strong">Vendor
                  locator: &nbsp;<span class="strong">{{
                    item.vendorlocator
                  }}</span></span>
              </b-col>
              <b-col class="text-right">
                &nbsp;<span class="strong">Confirmed</span><br />
                &nbsp;<span class="strong"> {{ item.classname }}</span>
                <br />
                Fare Basis: &nbsp;<span class="strong">{{
                  item.farebasiscode
                }}</span>
                <br />
                <div v-if="
                  isgroupetr == false">
                  <!-- Seat: &nbsp;<span class="strong">{{ items[0].seatno }}</span> -->
                  Seat: &nbsp;<span class="strong">{{ item.seatno }}</span>
                </div>
              </b-col>
            </b-row>

            <b-row class="border-secondary mt-1 text-center">
              <b-col>
                <!-- We recommend to try and check in online. This should be
                  available 24 hours before departure. <br />
                  Please check-in for European and Domestic flights at least 120
                  minutes in advance.<br />
                  For Intercontinental flights check-in as follows: Economy 180
                  minutes, Business Class 120 minutes, 1st Class 90 minutes.<br />
                  You must ensure that you hold a PASSPORT VALID FOR THE
                  DURATION OF YOUR TRIP and that you COMPLY WITH ANY
                  IMMUNISATION REQUIREMENTS/VISA REGULATIONS in force at any
                  particular time for the countries you intend to visit.<br /><br />

                  If you are travelling to the USA please be aware of the new
                  DoT Ruling which requires us to bring to your attention
                  additional information regarding the baggage rules of
                  individual carriers please visit website
                  https://mytripandmore.com/baggage.aspx and select your
                  carriers for further information.<br /><br />

                  The carriage of certain hazardous materials, like aerosols,
                  fireworks, and flammable liquids, aboard the aircraft is
                  forbidden. If you do not understand these restrictions,
                  further information may be obtained from your airline.<br />
                  Amex After Hours - Tel: 0044 2037 883595 -->
                <!-- {{ items[0].checkindetails }} -->
                <div v-html="$helpers.breaklines(items[0].checkindetails)"></div>
                <div class="text-right small">Ref: {{ items[0].id.toLowerCase() }}</div>
              </b-col>
            </b-row>
            <!-- GROUP BOOKING -->
            <div v-if="isgroupetr == true">
              <b-row class="mt-2">
                <b-col>
                  <h4>Passengers &amp; E-Ticket Numbers</h4>
                </b-col>
              </b-row>
              <b-row class="mt-2 border-secondary">
                <b-col class="border-secondary" v-for="(ticket, index) in items" :key="index" cols="6">
                  <b-row no-gutters>
                    <b-col cols="6">{{ ticket.passenger }}</b-col>
                    <b-col cols="2" class="text-right">{{
                      ticket.seatno
                    }}</b-col>
                    <b-col cols="4" class="text-right">
                      {{ ticket.ticketno }}</b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="mt-2">
                <b-col>
                  <h4>Group E-Ticket Receipt</h4>
                </b-col>
              </b-row>
              <b-row class="mt-2 border-secondary">
                <b-col class="border-right-secondary">Agency IATA Number:&nbsp;<span class="strong">{{
                  items[0].iatano
                    }}</span></b-col>
                <b-col>Form of Payment:<span class="strong">{{
                  items[0].formofpayment
                    }}</span>
                </b-col>
              </b-row>
              <b-row class="border-secondary mt-1">
                <b-col cols="3" class="border-right-secondary">Fare Calculation:</b-col>
                <b-col><span class="strong">{{
                  items[0].farecalculation
                    }}</span></b-col>
              </b-row>
              <b-row class="border-secondary mt-1">
                <b-col cols="3" class="border-right-secondary">Endorsements:</b-col>
                <b-col><span class="strong">{{items[0].endorsements}}</span></b-col>             
              </b-row>
            </div>
            <!-- SINGLE BOOKING -->
            <div v-else>
              <b-row class="mt-2">
                <b-col>
                  <h4>E-Ticket Receipt</h4>
                </b-col>
              </b-row>
              <b-row class="mt-2 border-secondary">
                <b-col class="border-right-secondary">Ticket:<span class="strong">&nbsp;{{ items[0].farecalculation ==
                  'CHARTER' ? '' : items[0].plateno }}{{
                      items[0].ticketno }}</span></b-col>
                <b-col class="border-right-secondary">Agency IATA:<span class="strong">&nbsp;{{ items[0].iatano
                }}</span></b-col>
                }}</span></b-col>
                <b-col>Form of Payment:<span class="strong">
                    {{ items[0].formofpayment }}</span>
                </b-col>
              </b-row>
              <b-row class="border-secondary mt-1">
                <b-col cols="3" class="border-right-secondary">Fare Calculation:
                </b-col>
                <b-col><span class="strong">{{
                  items[0].farecalculation
                    }}</span></b-col>
                }}</span></b-col>
              </b-row>
              <b-row class="border-secondary mt-1">
                <b-col cols="3" class="border-right-secondary">Endorsements:</b-col>
                <b-col><span class="strong"> {{ items[0].endorsements }}</span>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </b-card-body>


      <b-card-body v-if="items.length > 0 && documentformat == 'ETR_2'">
        <div id="eticket" class="mb-3 p-5 background-white text-secondary text-left componentview">
          <b-row class="my-2 border-bottom-secondary uppercase" style="text-align:justify">
            <b-col class="text-left w-100pct">
              <span class="text-3x strong ">
                {{
                  (items[0].items[0].startdate * 0.001) | moment("DD MMM YYYY")
                }}
              </span>
              <i class="px-2 fa fa-caret-right fa-2x "></i>
              <span class="text-3x strong">
                {{
                  (items[0].items[items[0].items.length - 1].enddate * 0.001) | moment("DD MMM YYYY")
                }}</span>
              <span class="text-3x strong"> TRIP TO {{ tripto(items[0].items) }}</span>
            </b-col>
          </b-row>
          <b-row class="header border-bottom-secondary" align-v="center">
            <b-col style="letter-spacing:0.1em">
              <div v-if="isgroupetr == false">
                <div>PREPARED FOR:</div>
                <div> <strong class="text-2x text-dark">{{ items[0].passenger }} </strong> </div>
              </div>
              <div class="my-2">RESERVATION CODE: <span class="pl-2">{{ items[0].locator }}</span> </div>
              <div> AIRLINE RESERVATION CODE: <span class="pl-2">{{ items[0].items[0].vendorlocator }} ({{
                items[0].items[0].operatingcarrier }})</span></div>

            </b-col>
            <b-col cols="auto" class="text-center">
              <img class="logo" src="/img/brand/RGB Travel Places Primary Logo.bmp" alt="Travel Places"
                style="height:40px" /></b-col>
            <b-col cols="auto" class="text-right fw-500 lh-12">
              <div class="strong">Travel Places</div>
              <div>Podium House, 61 Chapel Road, </div>
              <div> Worthing West Sussex, BN11 1HR</div>
              <div>01903 832888 </div>
              <div>Amex Out of Hours: 0203 788 3595</div>
              <div> TRAVEL CONSULTANT {{ items[0].agent }}</div>

            </b-col>
          </b-row>
          <div v-for="(item, index) in items[0].items" :key="index">
            <b-row class="my-3" no-gutters>
              <b-col cols="auto"><i class="fa fa-plane fa-4x text-muted"></i></b-col>
              <b-col class="ml-2">
                <span class="text-2x ">DEPARTURE:</span>
                <span class="text-2x strong uppercase px-2">
                  {{ $moment.unix(item.startdate * 0.001).utc(false).format("dddd DD MMM YYYY") }}
                </span>
                <i class="px-2 fa fa-caret-right fa-2x "></i>
                <span class="text-2x px-2">Arrival:</span>
                <span class="text-2x strong uppercase">
                  {{ $moment.unix(item.enddate * 0.001).utc(false).format("dddd DD MMM YYYY") }}
                </span>
                <div class="text-muted">
                  Please verify flight times prior to departure</div>
              </b-col>
            </b-row>
            <b-row class="border-light-legacy">
              <b-col cols="3" class="background-light">
                <div class="my-2">
                  <strong class="text-2x uppercase">
                    {{ item.operatingcarriername }} </strong><br />
                  <strong class="text-3x strong">{{ item.flightno }}</strong><br />
                </div>
                <div class="mb-2">
                  Duration:<br />
                  {{ (item.duration) }}<br />
                </div>
                <div class="mb-2">
                  Cabin:<br />
                  {{ item.cabin }}<br />
                </div>
                <div class="mb-2">
                  Status:<br />
                  <span v-if="item.status == 'HK'"> Confirmed</span>
                  <span v-else>{{ item.status }}</span>

                </div>
              </b-col>
              <b-col class="border-light-legacy">
                <b-row>
                  <b-col>
                    <div class="my-2">
                      <span class="text-3x strong"> {{ item.startcity }} </span><br />
                      {{ item.startcityname }} <br />
                      {{ item.startcountryname }}
                    </div>
                  </b-col>
                  <b-col cols="auto">
                    <div class="mt-3">
                      <i class="fa fa-caret-right fa-2x"></i>
                    </div>
                  </b-col>
                  <b-col>
                    <div class="my-2">
                      <span class="text-3x strong"> {{ item.endcity }} </span><br />
                      {{ item.endcityname }}
                      <br />
                      {{ item.endcountryname }}
                    </div>
                  </b-col>
                </b-row>
                <b-row class="border-top-light-legacy">
                  <b-col class="border-right-light-legacy">
                    <div class="mb-2">
                      Departing At: <br />
                      <span class="text-3x strong">{{ item.starttime }}</span><br />
                      <span>( {{ $moment.unix(item.startdate * 0.001).utc(false).format("ddd, MMM DD") }})</span>
                    </div>
                    <div class="mb-2">
                      Terminal: <br />
                      TERMINAL {{ item.startterminal }}<br />
                    </div>
                  </b-col>
                  <b-col class="">

                    <div class="mb-2">
                      Arriving At: <br />
                      <span class="text-3x strong">{{ item.endtime }}</span><br />
                      <span>( {{ $moment.unix(item.enddate * 0.001).utc(false).format("ddd, MMM DD") }})</span>
                    </div>
                    <div class="mb-2">
                      Terminal: <br />
                      TERMINAL {{ item.endterminal }}<br /></div>
                  </b-col>
                </b-row>
              </b-col>

              <b-col cols="3" class="border-light-legacy">
                <div class="my-2">
                  Aircraft:<br />
                  <span class="uppercase">{{ item.aircraftname }} </span>
                </div>
                <div class="mb-2">
                  Distance (in Miles): <br />
                  {{ item.distance }}<br />
                </div>
                <div class="mb-2">
                  Meals: <br />
                  <span v-if="item.mealcode"> {{ item.mealcode }} {{ item.mealdesc }}</span>
                  <v-else>Meals</v-else>

                </div>
                <div class="mb-2">
                  Est. emission: <br />
                  <span>{{ (item.emission * 1000).toFixed(2) }} kg CO2</span> <br />
                </div>

              </b-col>
            </b-row>
            <b-row class="my-2">
              <b-col>
                <div>
                  Checked Baggage: Adult, {{ item.baggage }} <br />
                  Cabin Baggage: N/A<br />
                </div>
              </b-col>
            </b-row>
            <div v-if="isgroupetr == true">
            </div>

            <div v-else>
              <b-row class="mt-3 background-light">
                <b-col>Passenger Name:</b-col>
                <b-col>Seats:</b-col>

                <b-col>eTicket Receipt(s):</b-col>
              </b-row>
              <b-row class="border-bottom-secondary">
                <b-col><i class="fa fa-angle-double-right mr-1"></i>{{ items[0].passenger }}</b-col>
                <b-col>
                  <span v-if="item.seatno">{{ item.seatno }}</span>
                  <span v-else>Check-In Required
                  </span></b-col>

                <b-col>{{ items[0].carrier_id }}{{ items[0].ticketno }}</b-col>
              </b-row>
            </div>
          </div>

          

          <b-row class=" py-2 uppercase">
            <b-col>
              <strong>Notes:</strong> <br />
              Please check your itinerary and advise us of any errors</b-col>
          </b-row>

          <b-row class="border-top-secondary-double py-2 background-light">
            <b-col>
              <span class="strong">Travel Places</span><br />
              Podium House, 61 Chapel Road, Wothing, West Sussex, BN11 1HR<br />
              01903 832888 Amex Out of Hours - 0203 788 3595
            </b-col>
          </b-row>
          <b-row class="background-light pb-2">
            <b-col> TRAVEL CONSULTANT: {{ items[0].agent }} </b-col>
          </b-row>

          <div v-if="isgroupetr == true" class="mt-2">
            <b-row>
              <b-col>
                <h4>Passengers &amp; E-Ticket Numbers</h4>
              </b-col>
            </b-row>
            <b-row class="mt-1 background-light">
              <b-col>Passenger Name:</b-col>
              <b-col class="text-right w-100px">Seats:</b-col>
              <b-col class="text-right">eTicket Receipt(s):</b-col>
              <b-col>Passenger Name:</b-col>
              <b-col class="text-right w-100px">Seats:</b-col>
              <b-col class="text-right">eTicket Receipt(s):</b-col>
            </b-row>
            <b-row class="mt-0">
              <b-col class="border-secondary" v-for="(ticket, index) in items" :key="index" cols="6">
                <b-row>
                  <b-col cols=""><i class="fa fa-angle-double-right mr-1"></i>{{ ticket.passenger }}</b-col>
                  <b-col class="text-right w-100px">
                    <span v-if="ticket.seatno">{{ ticket.seatno }}</span>
                    <span v-else>Check-In Required
                    </span></b-col>
                  <b-col cols="4" class="text-right"> {{ ticket.carrier_id }}{{ ticket.ticketno }}</b-col>

                </b-row>
              </b-col>
            </b-row>

              <b-row class="mt-4">
                <b-col>
                  <h4>Group E-Ticket Receipt</h4>
                </b-col>
              </b-row>
              <b-row class="mt-2 border-secondary">
                <b-col class="border-right-secondary">Agency IATA Number:&nbsp;<span class="strong">{{
                  items[0].iatano
                    }}</span></b-col>
                <b-col>Form of Payment:<span class="strong">{{
                  items[0].formofpayment
                    }}</span>
                </b-col>
              </b-row>
              <b-row class="border-secondary mt-1">
                <b-col cols="3" class="border-right-secondary">Fare Calculation:</b-col>
                <b-col><span class="strong">{{
                  items[0].farecalculation
                    }}</span></b-col>
              </b-row>
              <b-row class="border-secondary mt-1">
                <b-col cols="3" class="border-right-secondary">Endorsements:</b-col>
                <b-col><span class="strong">{{items[0].endorsements}}</span></b-col>             
              </b-row>

          </div>
          <div v-else>
              <b-row class="mt-3">
                <b-col>
                  <h4>E-Ticket Receipt</h4>
                </b-col>
              </b-row>
              <b-row class="mt-2 border-secondary">
                <b-col class="border-right-secondary">Ticket:<span class="strong">&nbsp;{{ items[0].farecalculation ==
                  'CHARTER' ? '' : items[0].plateno }}{{
                      items[0].ticketno }}</span></b-col>
                <b-col class="border-right-secondary">Agency IATA:<span class="strong">&nbsp;{{ items[0].iatano
                }}</span></b-col>
              
                <b-col>Form of Payment:<span class="strong">
                    {{ items[0].formofpayment }}</span>
                </b-col>
              </b-row>
              <b-row class="border-secondary mt-1">
                <b-col cols="3" class="border-right-secondary">Fare Calculation:
                </b-col>
                <b-col><span class="strong">{{
                  items[0].farecalculation
                    }}</span></b-col>
              
              </b-row>
              <b-row class="border-secondary mt-1">
                <b-col cols="3" class="border-right-secondary">Endorsements:</b-col>
                <b-col><span class="strong"> {{ items[0].endorsements }}</span>
                </b-col>
              </b-row>
              </div>

        </div>


      </b-card-body>

      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-right">
            <b-button-group>
              <b-button squared size="sm" variant="secondary" @click="discard">
                <i class="fa fa-chevron-left pr-1"></i>Back
              </b-button></b-button-group>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

import * as fs from "file-saver";

export default {
  name: "ETRView",
  data() {
    return {
      busy: false,
      loading: false,
      items: [],
      isgroupetr: false,
      documentformat: "ETR_1",
    };
  },
  methods: {
    async load() {
      this.busy = true;

      this.isgroupetr = this.selection.length > 1 ? true : false;

      this.items = [];

      let variables = {
        selected: this.$helpers.prepareforSave(this.selection),
        isgroupetr: this.isgroupetr,
        showseatno: true,
        dateformat: "dd-MMM-yy HH:mm",
        mssql: true,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query tickets(
              $selected: [Ticket_input]
              $isgroupetr: Boolean
              $showseatno: Boolean
              $dateformat: String
              $mssql: Boolean
            ) {
              tickets(
                selected: $selected
                isgroupetr: $isgroupetr
                showseatno: $showseatno
                dateformat: $dateformat
                mssql: $mssql
              ) {
                # used
                id
                locator
                plateno
                ticketno
                carrier_id
                dateissued
                passenger
                eventname
                agent
                farecalculation
                endorsements
                formofpayment
                iatano
                seatno
                checkindetails

                # not used
                #                 type
                #                 carrier
                #                 carrier_id
                #                 exchangeno
                #                 originalno
                #                 void_at
                #                 refund_at
                #                 blac
                #                 slac
                #                 title
                #                 firstname
                #                 surname
                #                 description
                #                 notes
                #                 datetravel
                #                 eventcode
                #                 invoiceno
                #                 emailed_at
                #                 tax
                #                 fare
                #                 fare_cost
                #                 fare_sell
                #                 fees
                #                 fare_total
                #                 fare_type
                #                 fare_calc
                #                 line_ri
                #                 class
                #                 flightno
                #                 reason
                #                 fileref
                #                 branch
                #                 issued_agent
                #                 data
                #                 lines
                #                 errors
                #                 warnings
                #                 tourcode
                #                 locked
                #                 booker
                #                 costcentre
                #                 yourref
                #                 zone
                #                 # OLD VERSION WILL BE REMOVED
                #                 entry
                #                 void
                #                 queued
                #                 emailed
                #                 agencybooking
                #                 agencyticketing
                #                 #agencyiatano
                #                 cabin
                #                 aircraft
                #                 routing
                #                 status
                #                 documentpdf
                #                 documentname
                #                 invoice_at
                #                 fare_details

                items {
                  #used
                  id
                  ticketno
                  startdate
                  starttime
                  startcity
                  startcityname
                  startcountryname
                  startterminal
                  operatingcarrier
                  operatingcarriername
                  enddate
                  endtime
                  endcity
                  endcityname
                  endcountryname
                  endterminal
                  aircraft
                  aircraftname
                  flightno
                  baggage
                  seatno
                  mealcode
                  mealdesc
                  classname
                  cabin
                  status
                  distance
                  emission
                  duration
                  vendorlocator
                  farebasiscode

                  #not used
                  # line
                  # type
                  # enddate
                  # marketingcarrier
                  #
                  # flightflown
                  # nstopovers
                  # seatstatus
                  # mealstatus
                  # classcode
                  # cabin
                  # quantity
                  # description
                  # status
                  # codedstatus
                  # statuscode
                }
              }
            }
          `,
          variables,
        });

        this.items = response.data.tickets;
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    async download() {
      this.busy = true;

      let variables = {
        selected: this.$helpers.prepareforSave(this.selection),
        isgroupetr: this.isgroupetr,
        showseatno: true,
        documentformat: this.documentformat,
        dateformat: "YYYY-MM-DD",
        mssql: true,
      };
      console.log("download variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query tickets(
              $selected: [Ticket_input]
              $isgroupetr: Boolean
              $showseatno: Boolean
              $documentformat: String
              $dateformat: String
              $mssql: Boolean
            ) {
              tickets(
                selected: $selected
                isgroupetr: $isgroupetr
                showseatno: $showseatno
                documentformat: $documentformat
                dateformat: $dateformat
                mssql: $mssql
              ) {
                documentname
                documentpdf
              }
            }
          `,
          variables,
        });
        if (response.data.tickets.length > 0) {
          let item = response.data.tickets[0];
          console.log("downloaded item", item);

          let byteCharacters = atob(item.documentpdf);
          let byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          let byteArray = new Uint8Array(byteNumbers);
          let blob = new Blob([byteArray], { type: "application/pdf" });
          fs.saveAs(blob, item.documentname + ".pdf");
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    tripto(context, options) {
      let items = context
      if (items.length == 1) {
        return items[0].endcityname + ", " + items[0].endcountryname
      } else {
        // CHECK HALF WAY THROUGH THE TRIP FOR TRIP TO
        let mid = Math.floor(items.length / 2);
        if (items[mid - 1].endcity == items[mid].startcity) {
          return items[mid - 1].endcityname + ", " + items[mid - 1].endcountryname
        }
        if (items[0].startcity == items[items.length - 1].endcity) {
          return items[items.length - 1].startcityname + ", " + items[items.length - 1].startcountryname
        }
      }
      return items[items.length - 1].endcityname + ", " + items[items.length - 1].endcountryname
    },

  },
};
</script>
/*
<span v-if="items[0].items.length > 1" class="text-3x strong">{{ items[0].items[items[0].items.length -
                1].startcityname }},
                {{ items[0].items[items[0].items.length - 1].startcountryname }}</span>
<span v-else class="text-3x strong">
                {{ items[0].items[items[0].items.length - 1].endcityname }},
                {{ items[0].items[items[0].items.length - 1].endcountryname }} </span>
*/
<style></style>
